import { updateLazy } from "Functions/lazy";
import client from "FrontendJsAssets/common/client";

export const initSets = () => {
    for (const setsTrigger of document.querySelectorAll(".js-sets-trigger")) {
        setsTrigger.addEventListener("click", (event) => {
            const targetId = setsTrigger.getAttribute("r-toggle-trigger");
            const targetElem = document.querySelector(`.js-sets-target[id="${targetId}"]`);
            const url = setsTrigger.dataset.url;

            if (!targetElem.classList.contains("has-sets-loaded")) {
                client.get(url).then((response) => {
                    targetElem.innerHTML = response.data;
                    targetElem.classList.add("has-sets-loaded");
                    updateLazy();

                    for (const setsTrigger of targetElem.querySelectorAll(
                        ".js-sets-trigger-close"
                    )) {
                        setsTrigger.addEventListener("click", (event) => {
                            const targetId = setsTrigger
                                .closest(".js-sets-target")
                                .getAttribute("id");

                            $(`[r-toggle-trigger="${targetId}"]`).click();
                        });
                    }
                });
            }
        });
    }
};
